import extract from './extract';

export default extract;
